/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ operation: NonNullable<unknown>, ms: NonNullable<unknown> }} Request_TimingInputs */

const cs_request_timing = /** @type {(inputs: Request_TimingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.operation} · ${i?.ms} ms`)
};

const en_request_timing = /** @type {(inputs: Request_TimingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.operation} · ${i?.ms} ms`)
};

/**
* | output |
* | --- |
* | "{operation} · {ms} ms" |
*
* @param {Request_TimingInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const request_timing = /** @type {((inputs: Request_TimingInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Request_TimingInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_request_timing(inputs)
	return cs_request_timing(inputs)
});